import { request } from '@/utils/request'
import API from '@/constants/apis'
import * as types from './mutation-types'

export const getHCHomePage = async ({
  commit
}) => {
  // const cards = await request(API.HOME_CARD, 'POST', {})
  // const banners = await request(API.HOME_BANNER, 'POST', {})
  const homeData = await request(API.HC_HOME_DATA, 'POST', {})
  if (homeData.success) {
    commit(types.UPDATE_HOME, {
      cards: homeData.cardsData,
      banners: homeData.bannersData,
      tickers: homeData.tickerData,
      userName: homeData.userName,
      userId: homeData.userId
    })
    return {
      success: true,
      cards: homeData.cardsData,
      banners: homeData.bannersData,
      tickers: homeData.tickerData,
      userName: homeData.userName,
      userId: homeData.userId
    }
  } else {
    commit(types.UPDATE_HOME, {
      cards: [],
      banners: [],
      tickers: []
    })
    return {
      success: false,
      userId: '',
      msg: homeData.msg,
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/huichang/actions.js